<ng-container *ngIf="!isLoading">
    <div>
        <div style="margin-left: 43%; margin-top: 0%; margin-bottom: 1%">
            <!-- <button
                [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px', 'font-size':'14px', 'font-weight':'600', 'text-align':'center'}, th : {'border': 'solid 1px', 'font-size':'16px', 'font-weight':'600', 'text-align':'center'}, div : {'font-size':'14px', 'font-weight':'600'}}"
                class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
                printSectionId="print-section" ngxPrint>
                print
            </button> -->

  <button class="noPrint"
        style="margin-top: 1%; margin-left: 2%"
        mat-raised-button color="primary"
        (click)="printPage()">
         Print
       </button>

            <button class="noPrint" style="margin-top: 2% 2% 0 2%; margin-left: 2%"
                (click)="exportExcel('Prantwise_Subscription_Report')" mat-raised-button color="primary">
                Export
            </button>
            <button mat-dialog-close class="btn noPrint">
                Close
            </button>
        </div>
    </div>
    <div>
        <div class="container" id="print-section">
            <table class="table table-bordered">
                <thead class="br_tp_bt">
                    <tr class="br_tp_bt">
                        <th class="br_tp_bt" colspan="7" class="largeHeading" style="border-left: 2px solid black; border-right: 2px solid black; color: black;">दि {{ endDate | date:"dd/MM/yyyy" }} च्या अंकाकरिता
                            वर्गणीदार सध्यस्थिती
                        </th>
                    </tr>
                    <tr>
                        <th class="br_right br_left" style="border-left: 2px solid black; color: black;">अनुक्रमांक</th>
                        <th class="br_right" style="color: black;">जिल्हा</th>
                        <th class="br_right" style="color: black;">पोस्ट</th>
                        <th class="br_right" style="color: black;">हस्ते</th>
                        <th class="br_right" style="color: black;">मॅगझीन</th>
                        <th class="br_right" style="color: black;">डिजिटल</th>
                        <th class="br_right" style="border-right: 2px solid black; color: black;">एकूण</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let item of showPrantData">
                        <tr class="br_tp_bt">
                            <td colspan="7" class="smallHeading total-bold" style="border-left: 2px solid black; border-right: 2px solid black; color: black;">{{ item['prantName'] }}</td>
                        </tr>
                        <ng-container *ngFor="let data of item.data; let i=index; let end=last">
                            <tr  *ngIf="!end">
                                <td class="br_right" style="text-align: center; border-left: 2px solid black; color: black;">{{ i+1 }}</td>
                                <td class="br_right" style="text-align: center; color: black;">{{ data['districtName'] }}</td>
                                <td class="br_right" style="text-align: right; color: black;">{{ data['post'] }}</td>
                                <td class="br_right" style="text-align: right; color: black;">{{ data['haste'] }}</td>
                                <td class="br_right" style="text-align: right; color: black;">{{ data['magazine'] }}</td>
                                <td class="br_right" style="text-align: right; color: black;">{{ data['digital'] }}</td>
                                <td style="text-align: right; border-right: 2px solid black; color: black;">{{ data['total'] }}</td>
                            </tr>
                            <tr  *ngIf="end" class="fontBold">
                                <td class="br_right total-bold" colspan="2" style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; color: black;">{{ data['name'] }}</td>
                                <!-- <td class="br_right" style="text-align: center;">{{ data['name'] }}</td> -->
                                <td class="br_right total-bold" style="text-align: right; border-top: 2px solid black; color: black;">{{ data['postTotal'] }}</td>
                                <td class="br_right total-bold" style="text-align: right; border-top: 2px solid black; color: black;">{{ data['hasteTotal'] }}</td>
                                <td class="br_right total-bold" style="text-align: right; border-top: 2px solid black; color: black;">{{ data['magzineTotal'] }}</td>
                                <td class="br_right total-bold" style="text-align: right; border-top: 2px solid black; color: black;">{{ data['digitalTotal'] }}</td>
                                <td class="total-bold" style="text-align: right; border-right: 2px solid black; border-top: 2px solid black; color: black;">{{ data['total'] }}</td>
                            </tr>
                        </ng-container>
                    </ng-container>
                    <!-- <tr class="br_tp_bt">
                        <td colspan="7" style="border-left: 2px solid black; border-right: 2px solid black;"></td>
                    </tr> -->
                    <tr *ngFor="let item of showOtherPrantData; let i=index">
                        <td class="br_right" style="text-align: center; border-left: 2px solid black; color: black;">{{ i+1 }}</td>
                        <td class="br_right" style="text-align: right; color: black;">{{ item['name'] }}</td>
                        <td class="br_right" style="text-align: right; color: black;">{{ item['post'] }}</td>
                        <td class="br_right" style="text-align: right; color: black;">{{ item['haste'] }}</td>
                        <td class="br_right" style="text-align: right; color: black;">{{ item['magazine'] }}</td>
                        <td class="br_right" style="text-align: right; color: black;">{{ item['digital'] }}</td>
                        <td style="text-align: right; border-right: 2px solid black; color: black;">{{ item['total'] }}</td>
                    </tr>
                    <!-- <tr>
                        <td colspan="5"></td>
                    </tr> -->
                    <tr class="fontBold br_tp_bt">
                        <!-- <td class="br_right" style="border-left: 2px solid black;"></td> -->
                        <td class="br_right total-bold" colspan="2" style="text-align: center; border-left: 2px solid black; color: black;">एकूण</td>
                        <td class="br_right total-bold" style="text-align: right; border-top: 2px solid black; color: black;">{{ totalPostTotal }}</td>
                        <td class="br_right total-bold" style="text-align: right; border-top: 2px solid black; color: black;">{{ totalHasteTotal }}</td>
                        <td class="br_right total-bold" style="text-align: right; border-top: 2px solid black; color: black;">{{ totalMagzineTotal }}</td>
                        <td class="br_right total-bold" style="text-align: right; border-top: 2px solid black; color: black;">{{ totalDigitalTotal }}</td>
                        <td class="total-bold" style="text-align: right; border-top: 2px solid black; border-right: 2px solid black; color: black;">
                            {{ totalPostTotal + totalHasteTotal + totalMagzineTotal + totalDigitalTotal}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</ng-container>
<div *ngIf="isLoading" class="main-loading">
    <span class="loader"></span>
    <p>Loading...</p>
</div>